module.exports = __webpack_public_path__ + "img/shade-doc-scanner.0cf3e7df.svg";